export default function formatNumberDecimal(num: number, decimalPlaces = 2) {
  if (isNaN(num)) return "Invalid number";

  return Number(num).toLocaleString("en-US", {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });
}
